import * as z from "zod";

export const socialLinksSchema = z.object({
  facebook: z.string().optional(),
  instagram: z.string().optional(),
  twitter: z.string().optional(),
  linkedin: z.string().optional(),
  youtube: z.string().optional(),
});

export type SocialLinks = z.infer<typeof socialLinksSchema>;
